const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000
const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000

interface PlanStatus {
  isExpired: boolean
  isExpiringSoon: boolean
  daysUntilExpiry: number
  deactivationDate: Date | null
}

export function usePlanStatus(planExpiredAt?: string): PlanStatus {
  if (!planExpiredAt) {
    return {
      isExpired: false,
      isExpiringSoon: false,
      daysUntilExpiry: 0,
      deactivationDate: null
    }
  }

  const now = new Date()
  const expiryDate = new Date(planExpiredAt)
  const diffMs = expiryDate.getTime() - now.getTime()
  const daysUntilExpiry = Math.ceil(diffMs / (24 * 60 * 60 * 1000))
  const isExpired = diffMs <= 0
  const isExpiringSoon = !isExpired && diffMs <= ONE_WEEK_MS
  const deactivationDate = isExpired
    ? new Date(expiryDate.getTime() + FIFTEEN_DAYS_MS)
    : null

  return { isExpired, isExpiringSoon, daysUntilExpiry, deactivationDate }
}
